export function buildQuotePdf(jsPDF, q, fonts) {
  const doc = new jsPDF({ unit: 'pt', format: 'a4', compress: true });
  doc.addFileToVFS('Inter-Regular.ttf', fonts.regular);
  doc.addFont('Inter-Regular.ttf', 'Inter', 'normal');
  doc.addFileToVFS('Inter-Bold.ttf', fonts.bold);
  doc.addFont('Inter-Bold.ttf', 'Inter', 'bold');

  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 42;
  const INK = [14, 26, 43], RED = [208, 32, 46], REDD = [150, 16, 28];
  const GREY = [102, 112, 128], LINE = [226, 229, 235], SOFT = [246, 247, 249];

  const tl = n => n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const font = (w, s, c) => { doc.setFont('Inter', w); doc.setFontSize(s); doc.setTextColor(...(c || INK)); };

  function logo(x, y, s) {
    doc.setFillColor(...RED);
    doc.triangle(x, y, x + s * 0.26, y, x + s * 0.5, y + s * 0.78, 'F');
    doc.triangle(x + s * 0.5, y + s * 0.78, x + s * 0.74, y, x + s, y, 'F');
    doc.setFillColor(...REDD);
    doc.triangle(x + s * 0.5, y + s * 0.78, x + s * 0.61, y + s, x + s * 0.39, y + s, 'F');
  }

  function footer(page, pages) {
    doc.setDrawColor(...LINE); doc.setLineWidth(0.6);
    doc.line(M, H - 54, W - M, H - 54);
    logo(M, H - 42, 10);
    font('bold', 7.5, INK); doc.text('VİZOVA', M + 15, H - 34);
    font('normal', 7, GREY);
    doc.text('Bu teklif ' + q.createdAt + ' tarihinde VİZOVA ile oluşturulmuş, kullanıcı onayıyla yayımlanmıştır.', M + 52, H - 34);
    doc.text('İşlem No: ' + q.txId + '   ·   Demo belgesidir, sentetik veri içerir.', M + 52, H - 24);
    doc.text('Sayfa ' + page + ' / ' + pages, W - M, H - 34, { align: 'right' });
  }

  // ---------- Header ----------
  logo(M, 40, 34);
  font('bold', 22, INK); doc.text('VİZOVA', M + 44, 62);
  font('normal', 7.5, GREY); doc.text('Yapay zekâ destekli operasyon katmanı', M + 45, 74);

  font('bold', 17, INK); doc.text('FİYAT TEKLİFİ', W - M, 52, { align: 'right' });
  const meta = [['Teklif No', q.no], ['Tarih', q.date], ['Geçerlilik', q.validUntil], ['Revizyon', 'R0']];
  let my = 68;
  meta.forEach(([k, v]) => {
    font('normal', 8, GREY); doc.text(k, W - M - 130, my);
    font('bold', 8, INK); doc.text(v, W - M, my, { align: 'right' });
    my += 11;
  });

  doc.setFillColor(...RED); doc.rect(M, 118, W - 2 * M, 2.2, 'F');

  // ---------- Parties ----------
  let y = 136;
  const colW = (W - 2 * M - 14) / 2;
  function party(x, title, lines) {
    doc.setFillColor(...SOFT); doc.setDrawColor(...LINE);
    doc.roundedRect(x, y, colW, 96, 3, 3, 'FD');
    doc.setFillColor(...RED); doc.rect(x, y, 2.5, 96, 'F');
    font('bold', 7.5, RED); doc.text(title, x + 14, y + 16);
    font('bold', 10.5, INK); doc.text(lines[0], x + 14, y + 32);
    font('normal', 8, GREY);
    lines.slice(1).forEach((l, i) => doc.text(doc.splitTextToSize(l, colW - 22)[0], x + 14, y + 46 + i * 11.5));
  }
  const s = q.seller, c = q.customer;
  party(M, 'TEKLİF VEREN', [s.name, s.address, s.city, 'VD: ' + s.taxOffice + '  ·  VKN: ' + s.vkn, s.phone + '  ·  ' + s.email]);
  party(M + colW + 14, 'MÜŞTERİ', [c.name, c.address, c.city, 'VD: ' + c.taxOffice + '  ·  VKN: ' + c.vkn, 'Yetkili: ' + c.contact + '  ·  ' + c.email]);

  // ---------- Intro ----------
  y += 118;
  font('normal', 9, INK);
  const intro = 'Sayın ' + c.contact + ', ' + q.date + ' tarihli talebiniz doğrultusunda hazırlanan fiyat teklifimizi aşağıda bilgilerinize sunarız. Fiyatlar Türk lirası cinsinden olup KDV hariçtir.';
  const introLines = doc.splitTextToSize(intro, W - 2 * M);
  doc.text(introLines, M, y);
  y += introLines.length * 12 + 12;

  // ---------- Items table ----------
  const cols = [
    { k: '#', x: M + 8, a: 'left' },
    { k: 'Ürün kodu', x: M + 26, a: 'left' },
    { k: 'Açıklama', x: M + 116, a: 'left' },
    { k: 'Miktar', x: M + 318, a: 'right' },
    { k: 'Birim fiyat', x: M + 392, a: 'right' },
    { k: 'İsk.', x: M + 428, a: 'right' },
    { k: 'Tutar', x: W - M - 8, a: 'right' }
  ];
  doc.setFillColor(...INK); doc.rect(M, y, W - 2 * M, 22, 'F');
  font('bold', 8, [255, 255, 255]);
  cols.forEach(cl => doc.text(cl.k, cl.x, y + 14.5, { align: cl.a }));
  y += 22;

  q.items.forEach((it, i) => {
    const rh = 34;
    if (i % 2 === 1) { doc.setFillColor(...SOFT); doc.rect(M, y, W - 2 * M, rh, 'F'); }
    font('normal', 8.5, GREY); doc.text(String(i + 1), cols[0].x, y + 14);
    font('bold', 7.6, INK); doc.text(it.code, cols[1].x, y + 14);
    font('bold', 8.5, INK); doc.text(it.name, cols[2].x, y + 14);
    font('normal', 7.2, GREY);
    doc.text(it.spec + '  ·  Teslim: ' + it.leadText, cols[2].x, y + 25);
    font('normal', 8.5, INK);
    doc.text(it.qty.toLocaleString('tr-TR') + ' ' + it.unit, cols[3].x, y + 14, { align: 'right' });
    doc.text(tl(it.price), cols[4].x, y + 14, { align: 'right' });
    doc.text(it.disc ? '%' + it.disc : '–', cols[5].x, y + 14, { align: 'right' });
    font('bold', 8.5, INK); doc.text(tl(it.net), cols[6].x, y + 14, { align: 'right' });
    y += rh;
    doc.setDrawColor(...LINE); doc.setLineWidth(0.5); doc.line(M, y, W - M, y);
  });

  // ---------- Totals ----------
  y += 16;
  const tx = W - M - 210;
  const rows = [['Brüt toplam', tl(q.gross)], ['İskonto', q.discount > 0 ? '−' + tl(q.discount) : tl(0)], ['Net toplam', tl(q.net)], ['KDV (%20)', tl(q.vat)]];
  let ty = y;
  rows.forEach(([k, v]) => {
    font('normal', 8.5, GREY); doc.text(k, tx, ty + 10);
    font('normal', 8.5, INK); doc.text(v + ' TL', W - M - 8, ty + 10, { align: 'right' });
    ty += 16;
  });
  doc.setFillColor(...INK); doc.rect(tx - 10, ty + 2, W - M - tx + 10, 26, 'F');
  font('bold', 9, [255, 255, 255]); doc.text('GENEL TOPLAM', tx, ty + 19);
  font('bold', 11, [255, 255, 255]); doc.text(tl(q.total) + ' TL', W - M - 8, ty + 19.5, { align: 'right' });

  // amount in words (left of totals)
  font('bold', 7.5, RED); doc.text('YALNIZ', M, y + 10);
  font('normal', 8.5, INK);
  const words = doc.splitTextToSize(q.totalWords, tx - M - 30);
  doc.text(words, M, y + 23);
  y = ty + 50;

  // ---------- Terms ----------
  font('bold', 9.5, INK); doc.text('Ticari şartlar', M, y);
  doc.setDrawColor(...LINE); doc.line(M, y + 6, W - M, y + 6);
  y += 20;
  const terms = [
    ['Ödeme', q.terms.payment], ['Teslim süresi', q.terms.lead], ['Teslim şekli', q.terms.delivery],
    ['Geçerlilik', q.terms.validity], ['Para birimi', 'Türk lirası (TL), KDV hariç'], ['Ambalaj', 'Standart ihracat ambalajı dahildir']
  ];
  const tcol = (W - 2 * M) / 2;
  terms.forEach((t, i) => {
    const x = M + (i % 2) * tcol, yy = y + Math.floor(i / 2) * 16;
    font('normal', 8, GREY); doc.text(t[0], x, yy);
    font('normal', 8, INK); doc.text(t[1], x + 74, yy);
  });
  y += Math.ceil(terms.length / 2) * 16 + 6;

  if (q.notes.length) {
    const noteLines = [];
    q.notes.forEach(n => doc.splitTextToSize('• ' + n, W - 2 * M - 24).forEach(l => noteLines.push(l)));
    const nh = noteLines.length * 11 + 22;
    doc.setFillColor(255, 247, 237); doc.setDrawColor(245, 204, 160);
    doc.roundedRect(M, y, W - 2 * M, nh, 3, 3, 'FD');
    font('bold', 7.5, [160, 90, 10]); doc.text('NOTLAR', M + 12, y + 14);
    font('normal', 8, [90, 60, 20]); doc.text(noteLines, M + 12, y + 27);
    y += nh + 16;
  } else {
    y += 8;
  }

  // ---------- Signatures ----------
  const sy = Math.max(y, H - 170);
  const sw = (W - 2 * M - 24) / 2;
  [[M, 'Hazırlayan', q.preparedBy, q.preparedRole, 'Oluşturma: ' + q.createdAt],
   [M + sw + 24, 'Onaylayan', q.approvedBy, q.approvedRole, 'Dijital onay: ' + q.approvedAt]].forEach(([x, t, n, r, d]) => {
    font('bold', 7.5, GREY); doc.text(t.toUpperCase(), x, sy);
    font('bold', 10, INK); doc.text(n, x, sy + 16);
    font('normal', 8, GREY); doc.text(r, x, sy + 28);
    doc.setDrawColor(...LINE); doc.line(x, sy + 58, x + sw, sy + 58);
    font('normal', 7, GREY); doc.text(d, x, sy + 70);
  });
  // approval stamp
  const stx = M + sw + 24 + sw - 70, sty = sy + 4;
  doc.setDrawColor(27, 138, 75); doc.setLineWidth(1.2);
  doc.roundedRect(stx, sty, 70, 36, 4, 4, 'S');
  font('bold', 8, [27, 138, 75]); doc.text('✓ ONAYLANDI', stx + 35, sty + 16, { align: 'center' });
  font('normal', 6.5, [27, 138, 75]); doc.text(q.approvedAtShort, stx + 35, sty + 27, { align: 'center' });

  footer(1, 1);
  return doc;
}
